import styled from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from '../../fields.constants';

export const Card = styled.section`
  padding: ${em(12)} ${em(11)};
  background: #fff;
  border: ${em(1)} solid ${PALETTE.line};
  border-radius: ${em(6)};
`;

export const Title = styled.h3`
  margin: 0 0 ${em(10)};
  font-size: ${rem(15)};
  color: ${PALETTE.ink};
`;

export const Label = styled.label`
  display: block;
  margin-bottom: ${em(6)};
  font-size: ${rem(12.5)};
  color: ${PALETTE.muted};
`;

export const Select = styled.select`
  width: 100%;
  margin-bottom: ${em(14)};
  padding: ${em(7)} ${em(9)};
  font-size: ${rem(13.5)};
  color: ${PALETTE.ink};
  background: #fff;
  border: ${em(1)} solid ${PALETTE.line};
  border-radius: ${em(6)};
`;

export const Warning = styled.div`
  margin-bottom: 10px;
  padding: 9px 11px;
  font-size: 12.5px;
  color: ${PALETTE.lateText};
  background: ${PALETTE.lateBg};
  border: 1px solid ${PALETTE.lateBorder};
  border-radius: 6px;

  b {
    display: block;
    margin-bottom: 2px;
    font-weight: 700;
  }
`;

const wideButton = `
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 14.5px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const PreviewButton = styled.button`
  ${wideButton}
  background: ${PALETTE.amber};

  &:hover:not(:disabled) {
    background: #a8740d;
  }
`;

export const DownloadButton = styled.button`
  ${wideButton}
  margin-top: 8px;
  background: ${PALETTE.brand};

  &:hover:not(:disabled) {
    background: ${PALETTE.brandDark};
  }
`;

export const ErrorNote = styled.p`
  margin: ${em(10)} 0 0;
  font-size: ${rem(12.5)};
  color: #b3261e;
`;

export const Sent = styled.div`
  margin-top: 10px;
  padding: 10px 12px;
  font-size: 12.5px;
  color: #2c6340;
  background: #eff8f1;
  border: 1px solid #bedcc6;
  border-radius: 6px;

  b {
    display: block;
    font-weight: 700;
    overflow-wrap: anywhere;
  }
`;
